import React, { useState, createContext, useContext } from 'react';
type CommitteeContextType = {
  selectedIndex: number;
  setSelectedIndex: (idx: number) => void;
};
const CommitteeContext = createContext<CommitteeContextType>({
  selectedIndex: 0,
  setSelectedIndex: () => {}
});
export function CommitteeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  return <CommitteeContext.Provider value={{
    selectedIndex,
    setSelectedIndex
  }} data-id="element-115">
      {children}
    </CommitteeContext.Provider>;
}
export function useCommitteeContext() {
  return useContext(CommitteeContext);
}